
import { defineComponent } from 'vue';
import { Icon } from '@iconify/vue';

export default defineComponent({
  name: 'CheckoutCartItem',
  components: { Icon },
  emits: ['quantity', 'remove'],
  props: {
    cartItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      env: process.env.VUE_APP_API_URL,
    };
  },
  methods: {
    formatCurrency(value: number | string) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
      }).format(Number(value) || 0);
    },
  },
});
